import { apiClient } from './api-client';

export interface TranslationQuestion {
  id: number | string;
  text: string;
  options?: Array<{
    id: string;
    text: string;
  }>;
}

export interface TranslationResult {
  questions: Array<{
    id: number | string;
    text: string;
    options?: Array<{
      id: string;
      text: string;
    }>;
  }>;
  batches_processed?: number;
  batches_successful?: number;
  batches_failed?: number;
  total_saved?: number;
  errors?: Array<{
    batch?: number;
    error: string;
  }>;
  has_errors?: boolean;
  warning?: string;
  request_id?: string;
}

export interface CreditEstimation {
  word_count: number;
  credits_needed: number;
}

/**
 * AI Translation service.
 *
 * Connecting to AI is centralized in Settings > AI (a single site-wide
 * credential owned by the core library), so this no longer authenticates or
 * carries a per-form integration id - it just translates and estimates.
 */
export const aiTranslationService = {
  /**
   * Translate form fields. The AI credential is site-wide; only the formId is
   * needed (to scope permission + save the translations to the right form).
   */
  async translate(
    targetLanguage: string,
    questions: TranslationQuestion[],
    formId: number
  ): Promise<TranslationResult> {
    return apiClient.callProxy('aITranslation', 'translate', {
      formId,
      target_language: targetLanguage,
      questions,
    });
  },

  /**
   * Estimate AI credits needed for a translation (local word count).
   */
  async estimateCredits(questions: TranslationQuestion[], formId: number): Promise<CreditEstimation> {
    return apiClient.callProxy('aITranslation', 'estimateCredits', {
      formId,
      questions,
    });
  },
};
